import {
  Field,
  GetStaticComponentProps,
  useComponentProps,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentWithContextProps } from 'lib/component-props';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import ArticlesSectionComponent from 'components/Sections/RelatedArticlesVariations/ArticlesSectionComponent';
import React from 'react';
import RelatedArticleTile from 'components/Tiles/RelatedArticleTile';
import { defaultLanguage } from 'temp/config';
import { articleService } from 'lib/services/ArticleService';
import { ArticleCardData } from 'model/Article';

type CapabilityType = {
  assetClasses: Array<string>;
  capabilityId: string;
  capabilityLimitedDisplay: string;
};

type DynamicRelatedArticlesSectionProps = {
  baseUrl: Field<string>;
  capabilityMappings: Field<Array<CapabilityType>>;
};

const DynamicRelatedArticlesSection = ({
  sitecoreContext,
  rendering,
}: ComponentWithContextProps): JSX.Element => {
  const isExperienceEditor = sitecoreContext.pageEditing;
  const articles = useComponentProps<ArticleCardData[]>(rendering.uid);

  if (isExperienceEditor) return <EEPlaceholder>Dynamic Related Articles Section</EEPlaceholder>;
  if (articles) {
    return (
      <ArticlesSectionComponent
        rendering={rendering}
        articles={articles}
        sliderCardComponent={RelatedArticleTile}
      />
    );
  }
};

export const getStaticProps: GetStaticComponentProps = async (rendering, layoutData) => {
  const fields = rendering.fields as unknown as DynamicRelatedArticlesSectionProps;
  const siteId = layoutData.sitecore.context?.siteRoot;
  const language = layoutData.sitecore.context.language ?? defaultLanguage;
  const assetClassName = layoutData.sitecore.context.assetClassName as string;
  const target =
    fields.capabilityMappings?.value.filter((item) =>
      item.assetClasses.some(
        (className) => className.toLowerCase() === assetClassName.toLowerCase()
      )
    ) ?? {};

  if (!fields || !target[0]) return [];

  return await articleService.getRelatedArticles(
    language,
    siteId,
    target[0]?.capabilityLimitedDisplay ?? '',
    [target[0]?.capabilityId] ?? []
  );
};

export default DynamicRelatedArticlesSection;
